import { useState, useEffect } from 'react'

const hasWindow = typeof window !== 'undefined'
const hasMatchMedia = hasWindow && typeof window.matchMedia === 'function'

let sharedDpr = hasWindow ? window.devicePixelRatio : 1
const listeners = new Set<(dpr: number) => void>()

function subscribe(callback: (dpr: number) => void) {
  listeners.add(callback)
  return () => {
    listeners.delete(callback)
  }
}

function startListening() {
  if (!hasMatchMedia) return
  const mql = window.matchMedia(`(resolution: ${sharedDpr}dppx)`)
  const handler = () => {
    sharedDpr = window.devicePixelRatio
    listeners.forEach((cb) => cb(sharedDpr))
    mql.removeEventListener('change', handler)
    startListening()
  }
  mql.addEventListener('change', handler)
}

startListening()

export const useDevicePixelRatio = (): number => {
  const [dpr, setDpr] = useState(sharedDpr)

  useEffect(() => subscribe(setDpr), [])

  return dpr
}
